module.exports = __webpack_public_path__ + "static/media/r_wide.6f1a0c30.png";